import CalcLoan from "../../desktop/calculator/CalcLoan"

const MobileCalculator = () => {
  return <CalcLoan isMobile={true} />
}

export default MobileCalculator
